import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-white text-xl font-bold mb-4">GARG ELECTRONICS</h3>
            <p className="text-sm mb-4">
              Kanpur's Most Trusted LED/LCD/Smart TV Repair Service Since 1996
            </p>
            <p className="text-sm font-semibold text-gray-400">30+ Years of Excellence</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-gray-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-gray-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-gray-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-gray-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Phone className="w-4 h-4 mr-2 mt-1 text-gray-400 flex-shrink-0" />
                <div className="text-sm">
                  <a href="tel:9565711092" className="hover:text-gray-400 transition-colors">
                    9565711092
                  </a>
                  <br />
                  <a href="tel:9565711092" className="hover:text-gray-400 transition-colors">
                    9565711092
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <Mail className="w-4 h-4 mr-2 mt-1 text-gray-400 flex-shrink-0" />
                <a
                  href="mailto:gargelectronic6387@gmail.com"
                  className="text-sm hover:text-gray-400 transition-colors break-all"
                >
                  gargelectronic6387@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="w-4 h-4 mr-2 mt-1 text-gray-400 flex-shrink-0" />
                <span className="text-sm">107/208 Nehru Nagar, Kanpur, UP</span>
              </li>
            </ul>
          </div>

          {/* Service Hours */}
          <div>
            <h4 className="text-white text-lg font-semibold mb-4">Service Hours</h4>
            <div className="flex items-start mb-4">
              <Clock className="w-4 h-4 mr-2 mt-1 text-gray-400 flex-shrink-0" />
              <div className="text-sm">
                <p className="font-semibold text-white">9:00 AM - 8:00 PM</p>
                <p>All 7 Days</p>
              </div>
            </div>
            <div className="bg-white text-gray-900 px-4 py-2 rounded-lg text-sm font-semibold inline-block">
              Same-Day Service Available
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Garg Electronics. All rights reserved. | 10,000+ Happy Customers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
